// El staff que un grupo lleva a un torneo de la RED (torneos_inscripciones_staff).
// En el torneo interno no aplica: ahi el staff es el del grupo. Regla del dueno
// (2026-09-07): minimo 1 fijo, tope lo define el torneo (max_staff_grupo, null = sin tope).

export const ROL_TORNEO = { ENTRENADOR: 'entrenador', ASISTENTE: 'asistente' };
export const ROL_TORNEO_LABEL = { entrenador: 'Entrenador', asistente: 'Asistente' };

const activos = (declarados) => (Array.isArray(declarados) ? declarados : []).filter((d) => d && d.activo !== false);

// { usados, tope, lleno, texto }. texto: "2 de 4" con tope, "2 declarados" sin tope.
export function cupoStaff(declarados, tope) {
  const usados = activos(declarados).length;
  const t = Number.isInteger(tope) && tope > 0 ? tope : null;
  const lleno = t !== null && usados >= t;
  const texto = t !== null
    ? `${usados} de ${t}`
    : `${usados} ${usados === 1 ? 'declarado' : 'declarados'}`;
  return { usados, tope: t, lleno, texto };
}

// El siguiente que se agrega entra como entrenador si todavia no hay uno; si no, asistente.
export function rolPorDefecto(declarados) {
  const hayEntrenador = activos(declarados).some((d) => d.rol_torneo === ROL_TORNEO.ENTRENADOR);
  return hayEntrenador ? ROL_TORNEO.ASISTENTE : ROL_TORNEO.ENTRENADOR;
}

// Para el tarjeton: a partir de las filas de get_staff_inscripcion (nombre, rol_torneo,
// imagen_url...), el entrenador y el primer asistente, con la forma { staff: {...} } que
// el tarjeton ya pinta.
export function coachesDesdeInscripcion(staffInscripcion) {
  const filas = Array.isArray(staffInscripcion) ? staffInscripcion.filter(Boolean) : [];
  const aStaff = (f) => ({ staff: { id: f.staff_id, nombre_completo: f.nombre, imagen_url: f.imagen_url || null, email: f.email || null } });
  const entrenador = filas.find((f) => f.rol_torneo === ROL_TORNEO.ENTRENADOR);
  const asistente = filas.find((f) => f.rol_torneo === ROL_TORNEO.ASISTENTE);
  return {
    headCoach: entrenador ? aStaff(entrenador) : null,
    assistantCoach: asistente ? aStaff(asistente) : null,
  };
}

// Que dice el trigger cuando no deja: si es un motivo accionable se muestra tal cual.
export function motivoStaff(error) {
  const msg = error?.message || '';
  return /Tope de staff|no pertenece|archivado|interno/i.test(msg) ? msg : 'No se pudo actualizar el staff.';
}
